import { create } from 'zustand';

export interface LayerConfig {
  id: string;
  name: string;
  visible: boolean;
  opacity: number;
}

interface LayerState {
  layers: LayerConfig[];
  toggleLayer: (id: string) => void;
  setOpacity: (id: string, opacity: number) => void;
}

const defaultLayers: LayerConfig[] = [
  { id: 'buildings', name: 'Bâtiments', visible: true, opacity: 0.75 },
  { id: 'roads', name: 'Voirie', visible: true, opacity: 0.8 },
  { id: 'vegetation', name: 'Végétation', visible: false, opacity: 0.6 },
  { id: 'water', name: 'Eau', visible: false, opacity: 0.7 },
  { id: 'public_facilities', name: 'Équipements publics', visible: false, opacity: 0.9 },
  { id: 'parcels', name: 'Parcelles', visible: false, opacity: 0.5 },
  { id: 'territories', name: 'Territoires', visible: true, opacity: 0.3 },
];

export const useLayerStore = create<LayerState>((set) => ({
  layers: defaultLayers,

  toggleLayer: (id) =>
    set((state) => ({
      layers: state.layers.map((l) =>
        l.id === id ? { ...l, visible: !l.visible } : l,
      ),
    })),

  setOpacity: (id, opacity) =>
    set((state) => ({
      layers: state.layers.map((l) =>
        l.id === id ? { ...l, opacity } : l,
      ),
    })),
}));
